const PinChatIcon = () => {
  return (
    <svg
      className="ChatRoomList__item__thumbnail__pin"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.75329 19.5 0.5 15.2467 0.5 10C0.5 4.75329 4.75329 0.5 10 0.5C15.2467 0.5 19.5 4.75329 19.5 10Z"
        fill="var(--c-secondary)"
        stroke="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.9977 7.02618L10.5529 6.58136C10.355 6.38351 10.355 6.06273 10.5529 5.86488L11.2693 5.14839C11.4672 4.95054 11.788 4.95054 11.9858 5.14839L14.8518 8.01434C15.0496 8.21219 15.0496 8.53297 14.8518 8.73082L14.1353 9.44731C13.9374 9.64516 13.6167 9.64516 13.4188 9.44731L12.974 9.00251L11.8437 10.6875C11.974 11.1565 12.0105 11.6529 11.9436 12.148L11.7248 13.7674C11.6873 14.0447 11.4321 14.2391 11.1549 14.2017C11.0449 14.1868 10.9429 14.1363 10.8645 14.0578L5.94233 9.13571C5.74448 8.93786 5.74448 8.61707 5.94233 8.41922C6.02078 8.34078 6.1228 8.29025 6.23273 8.27539L7.85221 8.05655C8.34732 7.98964 8.84367 8.02616 9.31271 8.15646L10.9977 7.02618Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.86572 11.0594L5.81862 13.1065L5.53714 14.4627L6.89335 14.1813L8.94045 12.1342L7.86572 11.0594Z"
        fill="white"
      />
    </svg>
  )
}

export default PinChatIcon
